// extracted by mini-css-extract-plugin
module.exports = {"TagEmptyState":"_3YFfxicV","EmptyState":"_18Am4kjF","title":"_2cEMmUh0","message":"HdBMBurN","actionButton":"_2O4OhjuS"};